import {
  Apple,
  Bone,
  Brain,
  ClipboardCheck,
  Droplets,
  Ear,
  Footprints,
  Hand,
  Heart,
  HeartPulse,
  Pill,
  ShieldAlert,
} from 'lucide-react';

// Health area → Lucide icon (FE-only map).
// Keys must match HealthRecords.area exactly. Unknown → HeartPulse (health cue).
//
// Icons policy (2026-08-24): new icons in Quinas App use lucide-react.
// Existing @heroicons/react imports stay until migrated deliberately —
// do not add new Heroicons in code novo. See docs/design-system/decisions.md #005.
//
// Tooth: Lucide has no tooth glyph — local SVG matching Lucide props (className, strokeWidth).
// Fisioterapia: Lucide has no single Foot — Footprints is the closest.

/** Minimal tooth outline (24×24), Lucide-compatible props. */
function Tooth({ className, strokeWidth = 2, size = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M8.5 3.5c-1.8 0-3 1.6-3 3.4 0 1.5.4 2.6.9 4 .6 1.7 1.1 3.5 1.1 5.3 0 1.4.5 2.8 1.5 2.8.7 0 1-.6 1.2-1.4.3-1.1.5-2.2.8-2.2s.5 1.1.8 2.2c.2.8.5 1.4 1.2 1.4 1 0 1.5-1.4 1.5-2.8 0-1.8.5-3.6 1.1-5.3.5-1.4.9-2.5.9-4 0-1.8-1.2-3.4-3-3.4-1.1 0-2 .5-2.5 1.2C10.5 4 9.6 3.5 8.5 3.5z" />
    </svg>
  );
}

export const DEFAULT_AREA_ICON = HeartPulse;

export const AREA_ICONS = {
  Dentista: Tooth,
  Fisioterapia: Footprints,
  Ortopedia: Bone,
  Dermatologia: Hand,
  'Otorrino e Pneumo': Ear,
  'Clinica Geral': Heart,
  Checkup: ClipboardCheck,
  'Gastro e Procto': Pill,
  Urologia: Droplets,
  Mental: Brain,
  Covid: ShieldAlert,
  Nutricionista: Apple,
};

export function getAreaIcon(area) {
  return AREA_ICONS[area] || DEFAULT_AREA_ICON;
}
